import { Provider } from 'react-redux'
import { setupStore } from '../store/store'
import { setMiscData } from '../store/miscSlice'
import React from 'react'
import { CourseTable } from './course_table'
import { CourseTablePreheader } from './course_table_preheader'
import { CourseButtonsRow } from './course_buttons_row'
import { CourseProductWarning} from './course_product_warning'
import { CoursePreheaderInfo } from './course_preheader_info'
import { NotificationContainer } from 'react-notifications'

const CourseDetailsRoot = (miscData) => {
  // 1. Setup the store
  const store = setupStore()
  // 2. Inject initial data from props into the store
  // NOTE: This runs only once when the component is initially rendered
  store.dispatch(setMiscData(miscData))

  return(
    <Provider store={store}>
      <NotificationContainer/>
      <CourseProductWarning/>
      <CourseButtonsRow/>
      <CoursePreheaderInfo/>
      <CourseTablePreheader/>
      <CourseTable/>
    </Provider>
  )
}

export default CourseDetailsRoot